import { GetNameTitle } from '../GlobalFunctions';
import { IAPISendEmail, IAPISendEmailContacts } from '../Interfaces';
import { IAmoSend } from './Interfaces';

const { REACT_APP_TYPE_BUILD } = process.env;

const CommonData = ({ eventMetrika, url }: { eventMetrika: string; url?: string }) => {
  return {
    source_name: 'dalli-service.com',
    pipeline_id: 3170194,
    created_at: Math.floor(new Date().getTime() / 1000),
    metadata: {
      form_id: eventMetrika,
      form_name: GetNameTitle({ eventMetrika }),
      form_page: url || '',
      form_sent_at: Math.floor(new Date().getTime() / 1000),
    },
  };
};

const DataForm = ({ eventMetrika }: { eventMetrika: string }) => {
  return {
    name: `Заявка с сайта - ${GetNameTitle({ eventMetrika })}`,
    _embedded: {
      tags: [{ name: 'Формы с сайта' }],
    },
  };
};

const DataContacts = ({ name, phone }: { name?: string; phone: string }) => {
  return [
    {
      name: name || '-',
      custom_fields_values: [
        {
          field_code: 'PHONE',
          values: [{ value: phone }],
        },
      ],
    },
  ];
};

// -----------------------------------------------------------------------

const GetDepartment = (num: number) => {
  const arr = ['Клиентский', 'Коммерческий', 'Отдел кадров'];
  return arr[num];
};

const GetCookie = (name: string) => {
  let matches = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
  );

  if (matches && matches[1] === 'null') {
    return undefined;
  }

  return matches ? decodeURIComponent(matches[1]) : undefined;
};

// utm, которые сохранились в cookie при заходе по ссылке с utm
export const GetUtmFromSavedInCookie = () => {
  return {
    source: GetCookie('_ks_ds_utm_source'),
    medium: GetCookie('_ks_ds_utm_medium'),
    campaign: GetCookie('_ks_ds_utm_campaign'),
    content: GetCookie('_ks_ds_utm_content'),
    term: GetCookie('_ks_ds_utm_term'),
  };
};

// utm, которые формирует Mango
export const GetUtmFromCookie = () => {
  const cookie = `utm=${GetCookie('mgo_sb_current')}` || '';
  const cookieParams = new URLSearchParams(decodeURI(cookie));
  const utmStr = cookieParams.get('utm');

  if (utmStr) {
    const utms = utmStr.split('|*|').join('&');
    const utmParams = new URLSearchParams(utms);

    return {
      utm_source: utmParams.get('src'),
      utm_medium: utmParams.get('mdm'),
      utm_campaign: utmParams.get('cmp'),
      utm_content: utmParams.get('trm'),
      utm_term: utmParams.get('src'),
    };
  }
  return {};
};

// -----------------------------------------------------------------------

interface IDataAmoMsg {
  dataSend: IAPISendEmailContacts;
  eventMetrika: string;
}
export const GetDataForAmoCRMmsg = ({ dataSend, eventMetrika }: IDataAmoMsg) => {
  const { name, phone, msg, orderNumber, department, url } = dataSend;

  const dataAmo: IAmoSend = {
    ...CommonData({ eventMetrika, url }),
    _embedded: {
      leads: [
        {
          ...DataForm({ eventMetrika }),
          custom_fields_values:
            REACT_APP_TYPE_BUILD === 'prod'
              ? DataAmoPROD({ url, msgType: { msg, orderNumber, department } })
              : DataAmoTEST({ url, msgType: { msg, orderNumber, department } }),
        },
      ],
      contacts: DataContacts({ name, phone }),
    },
  };

  return { ...dataSend, amoCRM: dataAmo };
};

interface IDataAmo {
  dataSend: IAPISendEmail;
  eventMetrika: string;
}
export const GetDataForAmoCRM = ({ dataSend, eventMetrika }: IDataAmo) => {
  const { name, phone, url } = dataSend;

  const dataAmo: IAmoSend = {
    ...CommonData({ eventMetrika, url }),
    _embedded: {
      leads: [
        {
          ...DataForm({ eventMetrika }),
          custom_fields_values:
            REACT_APP_TYPE_BUILD === 'prod'
              ? DataAmoPROD({ url, mainType: true })
              : DataAmoTEST({ url, mainType: true }),
        },
      ],
      contacts: DataContacts({ name, phone }),
    },
  };

  return { ...dataSend, amoCRM: dataAmo };
};

// -----------------------------------------------------------------------

const DataAmoPROD = ({
  url,
  mainType,
  msgType,
}: {
  url?: string;
  mainType?: boolean;
  msgType?: { msg: string; orderNumber?: string; department?: number };
}) => {
  const utmParams = new URLSearchParams(window.location.search);

  const { source, medium, campaign, content, term } = GetUtmFromSavedInCookie();

  const { utm_source, utm_medium, utm_campaign, utm_content, utm_term } = GetUtmFromCookie();

  const common = [
    {
      // страница, с которой отправили форму
      field_id: 543959,
      values: [{ value: url || '' }],
    },
    {
      field_id: 249253,
      values: [{ value: utmParams.get('utm_source') || source || utm_source || '(none)' }],
    },
    {
      field_id: 249255,
      values: [{ value: utmParams.get('utm_medium') || medium || utm_medium || '(none)' }],
    },
    {
      field_id: 249257,
      values: [{ value: utmParams.get('utm_campaign') || campaign || utm_campaign || '(none)' }],
    },
    {
      field_id: 249363,
      values: [{ value: utmParams.get('utm_content') || content || utm_content || '(none)' }],
    },
    {
      field_id: 249259,
      values: [{ value: utmParams.get('utm_term') || term || utm_term || '(none)' }],
    },

    {
      field_id: 538881,
      values: [{ value: DKT([utmParams.get('utm_source'), source, utm_source]) }],
    },
    {
      field_id: 538883,
      values: [{ value: DKT([utmParams.get('utm_medium'), medium, utm_medium]) }],
    },
    {
      field_id: 538885,
      values: [{ value: DKT([utmParams.get('utm_campaign'), campaign, utm_campaign]) }],
    },
    {
      field_id: 538887,
      values: [{ value: DKT([utmParams.get('utm_content'), content, utm_content]) }],
    },
    {
      field_id: 538889,
      values: [{ value: DKT([utmParams.get('utm_term'), term, utm_term]) }],
    },
  ];

  if (mainType) {
    return common;
  }

  if (msgType) {
    const { msg, orderNumber, department } = msgType;
    return [
      ...common,
      {
        field_id: 543961,
        values: [{ value: msg }],
      },
      {
        field_id: 543963,
        values: [{ value: orderNumber || '-' }],
      },
      {
        field_id: 543965,
        values: [{ value: department !== undefined ? GetDepartment(department) : 'Коммерческий' }],
      },
    ];
  }

  return [];
};

// -----------------------------------------------------------------------

const DataAmoTEST = ({
  url,
  mainType,
  msgType,
}: {
  url?: string;
  mainType?: boolean;
  msgType?: { msg: string; orderNumber?: string; department?: number };
}) => {
  const utmParams = new URLSearchParams(window.location.search);

  const common = [
    {
      // страница, с которой отправили форму
      field_id: 1420213,
      values: [{ value: url || '' }],
    },

    {
      field_id: 1416545,
      values: [{ value: utmParams.get('utm_source') || '' }],
    },
  ];

  if (mainType) {
    return common;
  }

  if (msgType) {
    const { msg, orderNumber, department } = msgType;
    return [
      ...common,
      {
        field_id: 1415965,
        values: [{ value: msg }],
      },
      {
        field_id: 1415905,
        values: [{ value: orderNumber || '-' }],
      },
      {
        field_id: 1415959,
        values: [{ value: department !== undefined ? GetDepartment(department) : 'Коммерческий' }],
      },
    ];
  }

  return [];
};

export const DKT = (utms: [string | null, string | undefined, string | null | undefined]) => {
  const [url, cookie, mango] = utms;
  return url ? `${url} - url` : cookie ? `${cookie} - cookie` : mango ? `${mango} - mango` : '(none) - 0';
};
